import { render, staticRenderFns } from "./ProjectPurchaseResultModal.vue?vue&type=template&id=1219d07c&"
import script from "./ProjectPurchaseResultModal.vue?vue&type=script&lang=js&"
export * from "./ProjectPurchaseResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports